import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const START = 'VOICE_TO_TEXT/START';

export const startActionSchema = objectSchemaOf<IStartAction>({
  type: Joi.string().required().valid(START),
  payload: Joi.object({
    conversationId: Joi.string().required(),
  }).required(),
});

export interface IStartAction {
  type: typeof START;
  payload: {
    conversationId: string;
  };
}

export const start = actionCreator({
  type: START,
  schema: startActionSchema,
});
